// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 460 ? "HomePage" : chunkId) + "." + {"452":"35aefc02","460":"1c4b7c46","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};